// extracted by mini-css-extract-plugin
module.exports = {"color_card_block":"Color_Cards_Block_color_card_block__17TUd"};